module.exports = __webpack_public_path__ + "static/img/vipBg.f23546e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vipBg.jpg
// module id = wLfl
// module chunks = 3